import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ProjectLocationPlanCoreModel,
} from '../store/models/project-location-plan-core.model';
import { HttpClient } from '@angular/common/http';
import { api } from '../consts/url';

@Injectable({ providedIn: 'root' })
export class ProjectLocationPlanCoreService {
  constructor(private readonly http: HttpClient) { }

  public findTypes(): Observable<
    ProjectLocationPlanCoreModel.API.CoreTypeResponse[]
  > {
    return this.http.get<ProjectLocationPlanCoreModel.API.CoreTypeResponse[]>(
      api.project.core.types,
    );
  }

  public getAll(projectId: string): Observable<
    ProjectLocationPlanCoreModel.PlanCoreDocument[]
  > {
    return this.http.get<ProjectLocationPlanCoreModel.PlanCoreDocument[]>(api.project.core.crud(projectId))
  }

  public updateMany(
    projectId: string,
    cores: ProjectLocationPlanCoreModel.API.BulkUpdateCoreDto,
  ): Observable<ProjectLocationPlanCoreModel.PlanCoreDocument[]> {
    return this.http.put<ProjectLocationPlanCoreModel.PlanCoreDocument[]>(api.project.core.bulkUpdate(projectId), cores)
  }

  public getPlanCores(
    projectId: string,
    locationId: string,
    planId: string
  ): Observable<
    ProjectLocationPlanCoreModel.PlanCoreDocument[]
  > {
    return this.http.get<ProjectLocationPlanCoreModel.PlanCoreDocument[]>(
      api.project.core.create(projectId, locationId, planId)
    );
  }

  public saveCore(
    projectId: string,
    locationId: string,
    planId: string,
    coreData: ProjectLocationPlanCoreModel.API.CreatePlanCoreDto
  ): Observable<
    ProjectLocationPlanCoreModel.PlanCoreDocument
  > {
    return this.http.post<ProjectLocationPlanCoreModel.PlanCoreDocument>(
      api.project.core.create(projectId, locationId, planId), coreData,
    );
  }

  public updateCore(
    coreId: string,
    updateData: ProjectLocationPlanCoreModel.API.UpdatePlanCoreDto,
  ): Observable<
    ProjectLocationPlanCoreModel.PlanCoreDocument
  > {
    return this.http.put<ProjectLocationPlanCoreModel.PlanCoreDocument>(
      api.project.core.crudById(coreId), { ...updateData },
    );
  }

  public copyCore(
    coreId: string,
  ): Observable<ProjectLocationPlanCoreModel.PlanCoreDocument> {
    return this.http.post<ProjectLocationPlanCoreModel.PlanCoreDocument>(
      api.project.core.copyCore(coreId), {}
    );
  }

  public deleteCore(
    coreId: string,
  ): Observable<ProjectLocationPlanCoreModel.PlanCoreDocument> {
    return this.http.delete<ProjectLocationPlanCoreModel.PlanCoreDocument>(
      api.project.core.crudById(coreId)
    );
  }

  public bulkDelete(
    projectId: string,
    coreIds: string[],
  ): Observable<boolean> {
    return this.http.delete<boolean>(
      api.project.core.bulkDelete(projectId),
      {
        body: {
          coreIds,
        },
      },
    );
  }

  public bulkCreate(
    projectId: string,
    cores: ProjectLocationPlanCoreModel.API.BulkCreateCoreDto[],
  ): Observable<ProjectLocationPlanCoreModel.PlanCoreDocument[]> {
    return this.http.post<ProjectLocationPlanCoreModel.PlanCoreDocument[]>(
      api.project.core.bulkCreate(projectId),
      {
        cores: cores
      },
    );
  }
}
